import React, { useEffect, useState } from 'react';
import './DataLibrary.scss';
import { NodeDefinition, NodeDefinitions } from '../../../editor/editorSlice';
import { Paginator } from 'primereact/paginator';
import { TabPanel, TabView } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import { DataLibraryFunctionItem } from './DataLibraryFunctionItem';

export const DataLibraryFunctionsList = ({bricks, onRefreshCatalog}: {
  bricks: NodeDefinitions,
  onRefreshCatalog: () => void
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(10);
  const [items, setItems] = useState<any[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const {t} = useTranslation();

  const renderTab = (header: string, nodes: NodeDefinition[]) => {
    return (
        <TabPanel key={header} header={<div>{header} ({nodes.length})</div>}>
          {nodes.length === 0 ? <div className="m-2">Aucun résultat</div> :
              <DataLibraryRows nodes={nodes} nbItems={nodes.length}/>}
        </TabPanel>
    );
  };

  useEffect(() => {
    setItems([
      renderTab(t('table.sources'), bricks.sources),
      renderTab(t('table.functions'), bricks.functions),
      renderTab(t('table.sinks'), bricks.sinks),
    ]);
  }, [bricks, currentPage]);

  const DataLibraryRows = ({nodes, nbItems}: { nodes: NodeDefinition[], nbItems: number }) => {
    const rows = [];
    for (
        let i = currentPage;
        i <
        (currentPage + cardsPerPage < nodes.length
            ? currentPage + cardsPerPage
            : nodes.length);
        i++
    ) {
      const id = nodes[i].runtimeMode + '/' + nodes[i].kind + '/' + nodes[i].name
      rows.push(
          <DataLibraryFunctionItem
              key={id}
              id={id}
              author={nodes[i].author}
              name={nodes[i].name}
              description={nodes[i].description}
              runtimeMode={nodes[i].runtimeMode}
              metadatas={nodes[i].metadatas}
              translatedMetadatas={nodes[i].translatedMetadatas}
              onRefreshCatalog={() => onRefreshCatalog()}
          />
      );
    }

    return <>{rows}
      <div style={{alignItems: 'center'}}>
        <Paginator
            first={currentPage}
            rows={cardsPerPage}
            totalRecords={nodes.length}
            onPageChange={paginate}
            className="surface-ground"
        ></Paginator>
      </div>
    </>;
  };

  const paginate = (event: any) => {
    setCurrentPage(event.first);
    setCardsPerPage(event.rows);
  };

  return (
      <div className="surface-ground mx-4">
        <div className="flex" style={{width: '100%'}}>
          <TabView style={{width: '100%'}} activeIndex={activeIndex}
                   onTabChange={(e) => setActiveIndex(e.index)}>
            {items}
          </TabView>
        </div>
      </div>
  );
};
